export enum AddAssigneesTypeEnum {
  ADD_SPLIT = "ADD_SPLIT",
  ADD_ASSIGNEE = "ADD_ASSIGNEE",
}
